import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTenant } from "../tenant/TenantContext";
import { LanguageSwitcher } from "../components/shared/LanguageSwitcher";
import "./WelcomeScreen.css";

interface WelcomeScreenProps {
  onStart: () => void;
}

export const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onStart }) => {
  const { t } = useTranslation();
  const tenant = useTenant();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className="welcome-screen">
      <LanguageSwitcher />
      <div className="welcome-content">
        <div className={`welcome-hero ${mounted ? "animate" : ""}`}>
          <img
            src={tenant.assets.heroImageUrl}
            alt={t("welcome.title")}
            className="hero-image"
          />
        </div>
        <h1 className={`welcome-title ${mounted ? "animate" : ""}`}>{t("welcome.title")}</h1>
        <p className={`welcome-description ${mounted ? "animate" : ""}`}>
          {t("welcome.description")}
        </p>
        <button
          type="button"
          onClick={onStart}
          className={`welcome-button ${mounted ? "animate" : ""}`}
          aria-label={t("welcome.startButton")}
        >
          {t("welcome.startButton")}
        </button>
        {tenant.meta.corporateOrganization && (
          <p className={`welcome-footer ${mounted ? "animate" : ""}`}>
            {t("welcome.footerMessage", { organization: tenant.meta.corporateOrganization })}
          </p>
        )}
      </div>
    </div>
  );
};

